// Utilidades para capturar Precio e Inventario eligiendo una presentación.
//
// El modelo interno del producto trabaja SIEMPRE en unidades base:
//   - productos.stock_total  -> stock en unidades base
//   - productos.precio_venta -> precio por unidad base
//
// Estas funciones permiten que el usuario escriba los datos en la presentación
// que quiera (ej: "1000 cajas" a "L255 la caja") y el sistema convierta
// automáticamente usando el factor de conversión ya configurado en Presentaciones
// (ej: 1 caja = 50 unidades):
//   stock_base   = cantidad_en_presentacion * factor
//   precio_base  = precio_de_la_presentacion / factor

// Opción por defecto: capturar en unidades base (factor 1).
export const UNIDAD_ENTRY = { presentacion_id: null, nombre: 'Unidad', factor: 1 };

// Construye la lista de opciones del selector: "Unidad" + las presentaciones del producto.
export function buildEntryOptions(presentaciones) {
  const extras = (presentaciones || [])
    .map((p) => ({
      presentacion_id: p.presentacion_id ?? p.id ?? null,
      nombre: p.nombre,
      factor: Number(p.factor_conversion ?? p.factor) || 1,
    }))
    .filter((p) => p.nombre && p.factor > 0);
  return [UNIDAD_ENTRY, ...extras];
}

// Formatea un número quitando ceros/decimales innecesarios para mostrarlo en un input.
export function fmtNum(n, decimals = 4) {
  if (n == null || !isFinite(n)) return '';
  const factor = Math.pow(10, decimals);
  const r = Math.round(n * factor) / factor;
  return String(r);
}

// Redondea dinero a 2 decimales.
function money(n) {
  return Math.round((Number(n) || 0) * 100) / 100;
}

// Convierte los valores que se muestran en pantalla de una presentación a otra,
// manteniendo constante la cantidad/precio en unidades base. Se usa cuando el
// usuario cambia el selector de presentación sin volver a teclear.
export function convertDisplayed(values, oldFactor, newFactor) {
  const oF = Number(oldFactor) > 0 ? Number(oldFactor) : 1;
  const nF = Number(newFactor) > 0 ? Number(newFactor) : 1;

  const convertQty = (v) => {
    if (v === '' || v == null) return v;
    const num = parseFloat(v);
    if (isNaN(num)) return v;
    return fmtNum((num * oF) / nF, 4);
  };
  const convertPrice = (v) => {
    if (v === '' || v == null) return v;
    const num = parseFloat(v);
    if (isNaN(num)) return v;
    // precio_base = precio / factor  ->  precio_nuevo = precio_base * nuevoFactor
    return fmtNum(money((num / oF) * nF), 2);
  };

  return {
    stock: convertQty(values.stock),
    precioVenta: convertPrice(values.precioVenta),
    precioCompra: convertPrice(values.precioCompra),
  };
}

// Convierte los valores capturados en la presentación seleccionada a unidades base,
// listos para enviar al backend.
export function toBaseValues(values, factor) {
  const f = Number(factor) > 0 ? Number(factor) : 1;
  const stockDisp = parseFloat(values.stock) || 0;
  const pvDisp = parseFloat(values.precioVenta) || 0;
  const pcDisp = parseFloat(values.precioCompra) || 0;
  return {
    stock: Math.round(stockDisp * f),
    precio_venta: money(pvDisp / f),
    precio_compra: money(pcDisp / f),
  };
}
